module.exports = __webpack_public_path__ + "img/icon_5_22.0ea93806.png";